module.exports = __webpack_public_path__ + "static/guarantee-8c00afa733a36bbe829741bac4d4c072.jpg";